import {FC} from 'react';

import {VisualContactModel} from '../../../models/api/visualContactModel';
import {renderContactCardHandle} from '../helpers/contactCardHandleHelpers';

/*
 * Props.
 */

interface ContactCardNoCardDetailsProps {
  visualContact: VisualContactModel;
}

/*
 * Component.
 */

export const ContactCardNoCardDetails: FC<ContactCardNoCardDetailsProps> = (props) => {
  const {visualContact} = props;

  return renderContactCardHandle({
    handle: visualContact.contact.handle,
    source: visualContact.contact.source,
  });
};
